<template>
	<div class="ui form">
		<div class="two fields">
			<div class="field">
				<div class="ui icon input" :class="{ loading: loading }">
					<input
						type="text"
						:placeholder="placeholder"
						:value="value"
						@input="onChange"
						@keypress.enter="onEnter"
						@keyup="onKeyup"
						@keydown="onKeyDown"
					/>
					<i class="search icon"></i>
				</div>
			</div>
			<div class="field">
				<slot />
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			loading: {
				type: Boolean,
				default: false,
			},
			placeholder: {
				type: String,
				default: 'Buscar...',
			},
			value: {
				type: String,
				default: '',
			},
		},
		data: function() {
			return {
				typingTimer: null,
				searching: false
			};
		},
		methods: {
			onChange: function($event) {
				// this.$emit('input', $event.target.value);
			},
			onEnter: function($event) {
				this.$emit('enter', $event.target.value);
			},
			onKeyup: function($event) {
				clearTimeout(this.typingTimer);
				this.searching = true;
  				this.typingTimer = setTimeout(()=>{ this.$emit('input', $event.target.value); this.searching = false; }, 300 );
			},
			onKeyDown: function($event) {
  				clearTimeout(this.typingTimer);
				this.searching = true;
			}

		},
	};
</script>

<style lang="scss" module>
	@import '@design';
</style>